const SearchInputWithResultsContainerStyle = `
  position: relative;
`;

export default SearchInputWithResultsContainerStyle;
